import React, { useState } from "react";
import ExlyModal from "common/Components/ExlyModal";
import SeeMoreStatsModal from "ui/pages/limitedOffer/seeMoreStatsModal";
import { statsColumns } from "ui/pages/limitedOffer/seeMoreStatsModalConfig";

import { Tooltip } from "@my-scoot/component-library-legacy";

import { IconButton } from "@material-ui/core";
import { MoreHorizOutlined as MoreIcon } from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import classnames from "classnames";

import WhatsappIcon from "assets/vectors/whatsap-broadcast/whatsapp_white.svg";

import {
  getStatusChip,
  whatsappCampaignStatusChoices,
} from "../../../constants";

import {
  campaignStepsData,
  WHATSAPP_CAMPAIGN_DESCRIPTIONS,
} from "ui/pages/whatsappBroadcast/whatsappBroadcast.constants";

import RenderPhoneNumber from "../RenderPhoneNumber";

import { useStyles } from "./MobileRow.styles";
import MobileCard from "ui/pages/SalesAndMarketing/components/MobileCard";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import {
  getPercentage,
  formatRevenue,
} from "features/Common/utils/common.utils";
import {
  DRIP_SOURCE,
  STATS_FIELDS,
} from "ui/pages/communications/CustomEmail/components/EmailListItem/EmailListItem.constants";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useRefreshStats } from "utils/hooks/useRefreshStats";
import CircularProgress from "@material-ui/core/CircularProgress";

export const MobileRow = ({
  data,
  time,
  alternate,
  recipients,
  onMoreClick,
  handlePreview,
  hasWriteAccess,
  type,
  handleEdit,
}) => {
  const classes = useStyles();
  const [showStatsModal, setShowStatsModal] = useState(false);
  const { handleRefreshStats, loading: refreshLoading } = useRefreshStats();

  const isDraft = type === whatsappCampaignStatusChoices.Drafts;
  const isScheduled = type === whatsappCampaignStatusChoices.Scheduled;

  const stats =
    [
      whatsappCampaignStatusChoices.Drafts,
      whatsappCampaignStatusChoices.Scheduled,
    ].indexOf(type) < 0
      ? [
          {
            title: STATS_FIELDS.sentTo,
            data: data?.sent_count,
            color: "#493AB1",
            icon: "send.png",
            tooltipText: "Number of users to whom the campaign was initiated",
          },
          {
            title: STATS_FIELDS.deliveredTo,
            data: data?.delivered_count,
            color: "#EDB183",
            icon: "mark_chat_unread.png",
            tooltipText: "Number of users to whom the message was delivered",
          },
          {
            title: STATS_FIELDS.openedRate,
            data: getPercentage(data?.read_count, data?.sent_count),
            subData: data?.read_count ?? 0,
            color: "#086F86",
            icon: "percent.png",
          },
        ]
      : [];

  const isShowRefreshStat = Boolean(
    !data?.retry_expiry ||
      (data?.retry_expiry && new Date(data.retry_expiry) > new Date())
  );

  return (
    <>
      <MobileCard
        alternate={alternate}
        className={!hasWriteAccess ? "disable_pointer" : ""}
        header={
          <div className="tw-flex tw-items-center tw-justify-between">
            <div className="tw-flex tw-items-center tw-gap-3">
              <ExlyImage src={WhatsappIcon} alt="whatsapp main logo" />

              <span
                className="tw-text-[#272522] tw-text-[16px] tw-font-medium tw-underline tw-cursor-pointer tw-max-w-[48vw] tw-truncate hover:tw-text-[#493AB1]"
                onClick={isDraft ? handleEdit : handlePreview}
              >
                To: {data?.audience?.segment?.title || recipients}
              </span>
            </div>

            <div className="tw-flex tw-items-center tw-gap-3">
              {getStatusChip({ type, classes })}

              <IconButton
                className="!tw-p-0 tw-mr-[16px] !tw-text-[#493AB1]"
                onClick={onMoreClick}
              >
                <MoreIcon />
              </IconButton>
            </div>
          </div>
        }
        content={[
          {
            title: "Campaign Name:",
            value: data?.title,
          },

          ...(time
            ? [
                {
                  title: isScheduled
                    ? "Scheduled For"
                    : isDraft
                    ? "Edited"
                    : "Sent",
                  value: time,
                },
              ]
            : []),

          ...(!isDraft && !isScheduled
            ? [
                {
                  value: <RenderPhoneNumber data={data} />,
                },
              ]
            : []),
          {
            title: "Bookings:",
            value: data?.total_bookings_received,
          },
          {
            title: "Revenue:",
            value: formatRevenue(data?.total_revenue),
          },
        ]}
        stats={stats}
        statColumns={2}
        footer={
          <div className="tw-flex tw-flex-col tw-w-full">
            {type === whatsappCampaignStatusChoices.Completed ? (
              <div className="tw-border-solid tw-border-[#E7E6E4] tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-w-full tw-p-3 tw-flex tw-gap-2 tw-items-center">
                <div
                  className={classnames(
                    classes.campaignStep,
                    classes[campaignStepsData[`${data?.status}`]?.className]
                  )}
                >
                  {campaignStepsData[`${data?.status}`]?.label}
                </div>
                <Tooltip
                  arrow
                  color="primary"
                  placement="top"
                  title={WHATSAPP_CAMPAIGN_DESCRIPTIONS[`${data?.status}`]}
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            ) : null}

            <div
              className="tw-bg-[#EEECF9] tw-text-[#493AB1] tw-p-3 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
              onClick={() => setShowStatsModal(true)}
            >
              <p className="tw-text-[14px] tw-font-medium tw-underline">
                See more stats
              </p>
              <KeyboardArrowRightIcon style={{ fontSize: 22 }} />
            </div>
          </div>
        }
      />

      <ExlyModal
        open={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        title="All stats and details"
        customFooter={
          isShowRefreshStat ? (
            <div className="tw-w-full tw-p-3">
              <button
                className="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border-none tw-bg-[#493AB1] tw-text-white tw-rounded-md tw-py-2 tw-font-medium"
                disabled={refreshLoading}
                onClick={() =>
                  handleRefreshStats({
                    isWhatsApp: true,
                    campaignUuid: data?.uuid,
                  })
                }
              >
                <p>Refresh stats</p>
                {refreshLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <RefreshIcon style={{ fontSize: 18 }} />
                )}
              </button>
            </div>
          ) : (
            <></>
          )
        }
      >
        <SeeMoreStatsModal
          record={data}
          columns={statsColumns(data)}
          isShowRefreshStat={isShowRefreshStat}
          isWhatsApp
          dripSource={DRIP_SOURCE.SALES_AND_MARKETING}
        />
      </ExlyModal>
    </>
  );
};
